/**
 * ClientsKpiWidget — vue d'ensemble clients.
 * Affiche : Total clients / dossiers Master / corbeille.
 */
import { useEffect, useState } from "react";
import { api } from "@/api";
import { Users, FolderTree, Trash2, FileText } from "lucide-react";

export default function ClientsKpiWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/clients/stats/summary").catch(() => ({ data: null })),
      api.get("/clients-trash").catch(() => ({ data: { count: 0 } })),
      api.get("/masters").catch(() => ({ data: { count: 0 } })),
    ]).then(([s, t, m]) => {
      setData({
        stats: s.data || {},
        trash: t.data?.count ?? 0,
        masters: m.data?.count ?? (m.data?.items?.length || 0),
      });
    });
  }, []);

  if (!data) {
    return <div className="text-center text-gray-400 text-xs py-4">Chargement…</div>;
  }
  const total = data.stats?.total ?? 0;
  const byStatus = data.stats?.by_status || {};
  const nouveaux = byStatus.nouveau ?? 0;
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="widget-clients-kpi">
      <Kpi icon={Users} value={total} label="Clients total" color="indigo" />
      <Kpi icon={FileText} value={nouveaux} label="Nouveaux" color="emerald" />
      <Kpi icon={FolderTree} value={data.masters} label="Dossiers Master" color="amber" />
      <Kpi icon={Trash2} value={data.trash} label="Corbeille" color="rose" />
    </div>
  );
}

function Kpi({ icon: Icon, value, label, color }) {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return (
    <div className={`rounded-lg border p-2 ${tones[color]}`}>
      <Icon className="w-3.5 h-3.5 mb-1 opacity-70" />
      <div className="text-xl font-bold">{value}</div>
      <div className="text-[10px] opacity-75">{label}</div>
    </div>
  );
}
